(function () {
  var SECTION_SELECTOR = '.oddit-section-ugc-carousel';
  var MEDIA_SELECTOR = '.oddit-section-ugc-carousel__card-media';
  var VISIBILITY_THRESHOLD = 0.5;

  function initScrollIndicator(section) {
    var track = section.querySelector('.oddit-section-ugc-carousel__track');
    var scrollThumb = section.querySelector('.oddit-section-ugc-carousel__scroll-thumb');

    if (!track || !scrollThumb) return;

    function updateScrollIndicator() {
      var scrollLeft = track.scrollLeft;
      var scrollWidth = track.scrollWidth - track.clientWidth;

      if (scrollWidth <= 0) {
        scrollThumb.style.left = '0%';
        return;
      }

      var scrollPercent = scrollLeft / scrollWidth;
      var thumbWidthPercent = (track.clientWidth / track.scrollWidth) * 100;
      var maxLeft = 100 - thumbWidthPercent;
      var thumbLeft = scrollPercent * maxLeft;

      scrollThumb.style.width = thumbWidthPercent + '%';
      scrollThumb.style.left = thumbLeft + '%';
    }

    track.addEventListener('scroll', updateScrollIndicator, { passive: true });
    updateScrollIndicator();

    var ro = new ResizeObserver(updateScrollIndicator);
    ro.observe(track);
  }

  function resetCard(media) {
    media.classList.remove('is-playing');
    var video = media.querySelector('[data-ugc-video]');
    if (!video) return;
    video.pause();
    try { video.currentTime = 0; } catch (e) {}
    video.muted = true;
    video.controls = false;
    video.setAttribute('aria-hidden', 'true');
  }

  function initPlayButtons(section) {
    var mediaEls = section.querySelectorAll(MEDIA_SELECTOR);

    section.querySelectorAll('[data-ugc-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest(MEDIA_SELECTOR);
        if (!media) return;

        var video = media.querySelector('[data-ugc-video]');
        if (!video) return;

        mediaEls.forEach(function (other) {
          if (other !== media && other.classList.contains('is-playing')) {
            resetCard(other);
          }
        });

        if (!video.src) {
          var src = video.getAttribute('data-src');
          if (!src) return;
          video.src = src;
        }

        video.muted = false;
        video.controls = true;
        video.removeAttribute('aria-hidden');
        media.classList.add('is-playing');

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      });
    });

    section.querySelectorAll('[data-ugc-video]').forEach(function (video) {
      video.addEventListener('ended', function () {
        var media = video.closest(MEDIA_SELECTOR);
        if (media) resetCard(media);
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (
              entry.intersectionRatio < VISIBILITY_THRESHOLD &&
              entry.target.classList.contains('is-playing')
            ) {
              resetCard(entry.target);
            }
          });
        },
        { threshold: [0, VISIBILITY_THRESHOLD, 1] }
      );
      mediaEls.forEach(function (media) {
        io.observe(media);
      });
    }
  }

  function initSection(section) {
    initScrollIndicator(section);
    initPlayButtons(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
